export const AvanceDashboard = ({ percAvan }) => {
  return (
    <div
      className="progress-widget-container anim"
      style={{ "--delay": ".1s" }}
    >
      <div>
        <ul className="list-unstyled">
          <li style={{ fontSize: "12px", textTransform: "uppercase" }}>
            <small>Avance</small>
          </li>
          <li>
            <b className="perc-value">{percAvan}%</b>
          </li>
        </ul>
      </div>
      <div>
        <div className="progress-bar-h">
          <div
            className="progress-bar-perc"
            style={{ width: `${percAvan}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};
